import { render, staticRenderFns } from "./SidebarCard.vue?vue&type=template&id=6eda542c"
import script from "./SidebarCard.vue?vue&type=script&lang=js"
export * from "./SidebarCard.vue?vue&type=script&lang=js"
import style0 from "./SidebarCard.vue?vue&type=style&index=0&id=6eda542c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports